<template>
  <b-container class="pt-3">
    <b-button v-print="'#print-quotation'">列印</b-button>
    <print-page />
  </b-container>
</template>
<script>
import print from "vue-print-nb";
import PrintPage from "@/components/print/quotation";

export default {
  name: "QuotationPrint",
  components: { PrintPage },
  directives: {
    print,
  },
  mounted() {},
};
</script>
